import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import App from './App';

// React 앱을 DOM에 렌더링
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
